/* Product-card "ADD TO CART":
   - single-variant products are added straight to the cart (button shows "ADDED ✓", header count updates)
   - products with options open a quick view (photo, price, option pills, quantity, add to cart) */
(() => {
  const money = (cents) => `₹ ${(Number(cents) / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;

  const updateCount = (count) => {
    document.querySelectorAll('[data-ps-cart-count]').forEach((el) => { el.textContent = count; });
  };

  async function addToCart(id, quantity = 1) {
    if (window.PsCart && typeof window.PsCart.add === 'function') return window.PsCart.add(id, quantity);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) }] }),
    });
    if (!res.ok) throw new Error((await res.json().catch(() => ({}))).description || 'Could not add to cart');
    const cart = await (await fetch('/cart.js')).json();
    updateCount(cart.item_count);
    return cart;
  }

  const flash = (btn, text, ms = 1600) => {
    const label = btn.dataset.label || btn.textContent;
    btn.dataset.label = label;
    btn.textContent = text;
    clearTimeout(btn._flash);
    btn._flash = setTimeout(() => { btn.textContent = label; }, ms);
  };

  /* ---------- Quick view ---------- */
  let dialog;
  function buildDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'ps-qv';
    dialog.setAttribute('aria-labelledby', 'ps-qv-title');
    dialog.innerHTML = `
      <div class="ps-qv__blobs" aria-hidden="true">
        <svg class="ps-qv__blob ps-qv__blob--left" viewBox="0 0 522.957 283.927" preserveAspectRatio="xMinYMin meet" focusable="false"><path fill="currentColor" d="M522.957 0 C511.538 27.332 486.174 74.471 456.118 95.009 C428.459 113.909 389.282 117.781 355.774 116.475 C316.455 114.943 277.688 100.724 238.366 99.283 C199.044 97.843 157.21 104.859 127.457 130.526 C101.602 152.831 88.397 185.862 72.286 215.925 C56.174 245.987 33.316 276.258 0 283.927 L0 0 H522.957 Z"/></svg>
        <svg class="ps-qv__blob ps-qv__blob--right" viewBox="0 0 676.94 388.2" preserveAspectRatio="xMaxYMax meet" focusable="false"><path fill="currentColor" d="M669.83,388.2H0c4.28-13.41,13.97-25.99,25.33-34.68,61.99-47.47,159.81-20.53,220.77-69.29,49.92-39.93,56.67-116.62,105.36-158.02,37.82-32.16,91.81-35.53,137.32-55.49,35.83-15.71,66.11-41.64,100.32-60.61,1.85-1.02,3.74-2.02,5.68-2.98,11.65-5.76,24.71-9.72,36.56-5.1,12.74,4.96,19.93,18.34,24.58,31.17,9.74,26.87,13.1,55.57,15.57,84.04,7.79,90.11,7.22,180.95-1.66,270.96Z"/></svg>
      </div>
      <button class="ps-qv__close" type="button" aria-label="Close" data-qv-close>&times;</button>
      <div class="ps-qv__inner">
      <div class="ps-qv__media"><img class="ps-qv__img" alt="" width="600" height="600"></div>
      <div class="ps-qv__body">
        <h2 class="ps-qv__title" id="ps-qv-title"></h2>
        <p class="ps-qv__price"></p>
        <div class="ps-qv__options"></div>
        <div class="ps-qv__buy">
          <div class="ps-qv__qty">
            <button type="button" data-qv-qty="-1" aria-label="Decrease quantity">−</button>
            <input type="number" min="1" value="1" inputmode="numeric" aria-label="Quantity">
            <button type="button" data-qv-qty="1" aria-label="Increase quantity">+</button>
          </div>
          <button class="ps-qv__atc" type="button">ADD TO CART</button>
        </div>
        <p class="ps-qv__msg" role="status" aria-live="polite"></p>
        <a class="ps-qv__link" href="#">View full details →</a>
      </div>
      </div>`;
    document.body.appendChild(dialog);
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog || e.target.closest('[data-qv-close]')) dialog.close();
    });
    dialog.querySelectorAll('[data-qv-qty]').forEach((b) => b.addEventListener('click', () => {
      const input = dialog.querySelector('.ps-qv__qty input');
      input.value = Math.max(1, (Number(input.value) || 1) + Number(b.dataset.qvQty));
    }));
  }

  async function openQuickView(handle, trigger) {
    if (!dialog) buildDialog();
    trigger.classList.add('is-loading');
    let product;
    try {
      product = await (await fetch(`/products/${handle}.js`)).json();
    } catch (err) {
      window.location.href = `/products/${handle}`;
      return;
    } finally {
      trigger.classList.remove('is-loading');
    }

    const img = dialog.querySelector('.ps-qv__img');
    const titleEl = dialog.querySelector('.ps-qv__title');
    const priceEl = dialog.querySelector('.ps-qv__price');
    const optsEl = dialog.querySelector('.ps-qv__options');
    const atc = dialog.querySelector('.ps-qv__atc');
    const msg = dialog.querySelector('.ps-qv__msg');
    const qty = dialog.querySelector('.ps-qv__qty input');
    // Same colours as the product page (accent, page background, blob colours) — passed from the card
    dialog.setAttribute('style', trigger.dataset.qvStyle || '');
    dialog.querySelector('.ps-qv__link').href = product.url;
    titleEl.textContent = product.title;
    qty.value = 1;
    msg.textContent = '';

    const firstAvailable = product.variants.find((v) => v.available) || product.variants[0];
    const selected = [...firstAvailable.options];

    // Option pills (one row per option)
    optsEl.innerHTML = '';
    product.options.forEach((opt, i) => {
      const group = document.createElement('fieldset');
      group.className = 'ps-qv__opt';
      group.innerHTML = `<legend>${opt.name}</legend>`;
      const row = document.createElement('div');
      row.className = 'ps-qv__pills';
      opt.values.forEach((value) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'ps-qv__pill';
        b.textContent = value;
        b.setAttribute('aria-pressed', String(selected[i] === value));
        b.addEventListener('click', () => { selected[i] = value; sync(); });
        row.appendChild(b);
      });
      group.appendChild(row);
      optsEl.appendChild(group);
    });

    let current = firstAvailable;
    function sync() {
      current = product.variants.find((v) => v.options.every((o, i) => o === selected[i]));
      optsEl.querySelectorAll('.ps-qv__opt').forEach((group, i) => {
        group.querySelectorAll('.ps-qv__pill').forEach((b) => b.setAttribute('aria-pressed', String(b.textContent === selected[i])));
      });
      const src = (current && current.featured_image && current.featured_image.src) || product.featured_image;
      if (src) img.src = `${src.split('?')[0]}?width=600`;
      img.alt = product.title;
      priceEl.textContent = current ? money(current.price) : '';
      const ok = !!(current && current.available);
      atc.disabled = !ok;
      atc.textContent = current ? (ok ? 'ADD TO CART' : 'SOLD OUT') : 'UNAVAILABLE';
    }
    sync();

    atc.onclick = async () => {
      if (!current) return;
      atc.disabled = true;
      atc.textContent = 'ADDING…';
      try {
        await addToCart(current.id, qty.value);
        atc.textContent = 'ADDED ✓';
        msg.textContent = `${product.title} added to your cart.`;
        setTimeout(() => { if (dialog.open) dialog.close(); }, 900);
      } catch (err) {
        atc.textContent = 'TRY AGAIN';
        msg.textContent = err.message;
      } finally {
        setTimeout(() => { atc.disabled = false; if (atc.textContent !== 'TRY AGAIN') sync(); }, 1000);
      }
    };

    dialog.showModal();
  }

  document.addEventListener('click', async (event) => {
    const qv = event.target.closest('[data-ps-card-qv]');
    if (qv) {
      event.preventDefault();
      openQuickView(qv.dataset.handle, qv);
      return;
    }
    const btn = event.target.closest('[data-ps-card-atc]');
    if (!btn) return;
    event.preventDefault();
    const id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.classList.add('is-loading');
    btn.disabled = true;
    try {
      await addToCart(id, 1);
      flash(btn, 'ADDED ✓');
    } catch (err) {
      console.error('Card add to cart failed', err);
      flash(btn, 'TRY AGAIN');
    } finally {
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }
  });
})();
